import _inherits from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/regenerator";
import { getUserAgent } from 'universal-user-agent';
import { Collection } from 'before-after-hook';
import { request } from '@octokit/request';
import { withCustomRequest } from '@octokit/graphql';
import { createTokenAuth } from '@octokit/auth-token';
var VERSION = "3.4.0";

var Octokit = /*#__PURE__*/function () {
  function Octokit() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Octokit);

    var hook = new Collection();
    var requestDefaults = {
      baseUrl: request.endpoint.DEFAULTS.baseUrl,
      headers: {},
      request: Object.assign({}, options.request, {
        // @ts-ignore internal usage only, no need to type
        hook: hook.bind(null, "request")
      }),
      mediaType: {
        previews: [],
        format: ""
      }
    }; // prepend default user agent with `options.userAgent` if set

    requestDefaults.headers["user-agent"] = [options.userAgent, "octokit-core.js/".concat(VERSION, " ").concat(getUserAgent())].filter(Boolean).join(" ");

    if (options.baseUrl) {
      requestDefaults.baseUrl = options.baseUrl;
    }

    if (options.previews) {
      requestDefaults.mediaType.previews = options.previews;
    }

    if (options.timeZone) {
      requestDefaults.headers["time-zone"] = options.timeZone;
    }

    this.request = request.defaults(requestDefaults);
    this.graphql = withCustomRequest(this.request).defaults(requestDefaults);
    this.log = Object.assign({
      debug: function debug() {},
      info: function info() {},
      warn: console.warn.bind(console),
      error: console.error.bind(console)
    }, options.log);
    this.hook = hook; // (1) If neither `options.authStrategy` nor `options.auth` are set, the `octokit` instance
    //     is unauthenticated. The `this.auth()` method is a no-op and no request hook is registered.
    // (2) If only `options.auth` is set, use the default token authentication strategy.
    // (3) If `options.authStrategy` is set then use it and pass in `options.auth`. Always pass own request as many strategies accept a custom request instance.
    // TODO: type `options.auth` based on `options.authStrategy`.

    if (!options.authStrategy) {
      if (!options.auth) {
        // (1)
        this.auth = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    type: "unauthenticated"
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      } else {
        // (2)
        var auth = createTokenAuth(options.auth); // @ts-ignore  ¯\_(ツ)_/¯

        hook.wrap("request", auth.hook);
        this.auth = auth;
      }
    } else {
      var authStrategy = options.authStrategy,
          otherOptions = _objectWithoutProperties(options, ["authStrategy"]);

      var _auth = authStrategy(Object.assign({
        request: this.request,
        log: this.log,
        // we pass the current octokit instance as well as its constructor options
        // to allow for authentication strategies that return a new octokit instance
        // that shares the same internal state as the current one. The original
        // requirement for this was the "event-octokit" authentication strategy
        // of https://github.com/probot/octokit-auth-probot.
        octokit: this,
        octokitOptions: otherOptions
      }, options.auth)); // @ts-ignore  ¯\_(ツ)_/¯


      hook.wrap("request", _auth.hook);
      this.auth = _auth;
    } // apply plugins
    // https://stackoverflow.com/a/16345172


    var classConstructor = this.constructor;
    classConstructor.plugins.forEach(function (plugin) {
      Object.assign(_this, plugin(_this, options));
    });
  }

  _createClass(Octokit, null, [{
    key: "defaults",
    value: function defaults(_defaults) {
      var OctokitWithDefaults = /*#__PURE__*/function (_this2) {
        _inherits(OctokitWithDefaults, _this2);

        var _super = _createSuper(OctokitWithDefaults);

        function OctokitWithDefaults() {
          var _this3;

          _classCallCheck(this, OctokitWithDefaults);

          var options = (arguments.length <= 0 ? undefined : arguments[0]) || {};

          if (typeof _defaults === "function") {
            _this3 = _super.call(this, _defaults(options));
            return _possibleConstructorReturn(_this3);
          }

          return _super.call(this, Object.assign({}, _defaults, options, options.userAgent && _defaults.userAgent ? {
            userAgent: "".concat(options.userAgent, " ").concat(_defaults.userAgent)
          } : null));
        }

        return OctokitWithDefaults;
      }(this);

      return OctokitWithDefaults;
    }
    /**
     * Attach a plugin (or many) to your Octokit instance.
     *
     * @example
     * const API = Octokit.plugin(plugin1, plugin2, plugin3, ...)
     */

  }, {
    key: "plugin",
    value: function plugin() {
      var _a;

      var currentPlugins = this.plugins;

      for (var _len = arguments.length, newPlugins = new Array(_len), _key = 0; _key < _len; _key++) {
        newPlugins[_key] = arguments[_key];
      }

      var NewOctokit = (_a = /*#__PURE__*/function (_this4) {
        _inherits(_a, _this4);

        var _super2 = _createSuper(_a);

        function _a() {
          _classCallCheck(this, _a);

          return _super2.apply(this, arguments);
        }

        return _a;
      }(this), _a.plugins = currentPlugins.concat(newPlugins.filter(function (plugin) {
        return !currentPlugins.includes(plugin);
      })), _a);
      return NewOctokit;
    }
  }]);

  return Octokit;
}();

Octokit.VERSION = VERSION;
Octokit.plugins = [];
export { Octokit };